module.exports = __webpack_public_path__ + "static/media/drier.1b95e18b.png";